export default __webpack_public_path__ + "static/media/logo.7932b87d.svg";